module.exports = __webpack_public_path__ + "static/media/help.a53bd729.svg";